<template>
  <div class="home">
    <div class="modal-overlay" v-if="show">
      <div class="modal">
        <b @click="show = false">X</b>
       <iframe src="https://www.youtube.com/embed/eFAosb8GdHM"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen>
      </iframe>
      </div>
    </div>
    <div class="container-home">
      <div class="slide">
       <banner-slider @modal="show = true">
          <img
            src="@/assets/images/slidersHome/manzana.jpg"
            data-text="Excelencia, frescura y calidad en fruta fina."
            alt="Manzana">
          <img
            src="@/assets/images/slidersHome/frutosRojos.jpg"
            data-text="Amplio surtido , variedad y disponibilidad."
            alt="Frutos Rojos">
          <img
            src="@/assets/images/slidersHome/durazno.jpg"
            data-text="Vocación de atención al cliente y servicio."
            alt="Durazno">
          <img
            src="@/assets/images/slidersHome/chabacanos.jpg"
            data-text="Mejora continua para la mejor calidad."
            alt="Chabacanos">
          <!-- <img
            src="@/assets/images/slidersHome/uva.jpg"
            data-text="Comercialización de fruta de clase mundial."
            alt="Uvas"> -->
          <img
            src="@/assets/images/slidersHome/ciruela.jpg"
            data-text="Infraestructura de ultima generación e innovación continua."
            alt="Ciruela">
          <img
            src="@/assets/images/slidersHome/kiwi.jpg"
            data-text="Estrictos protocolos de conservación de producto."
            alt="Kiwi">
          <img
            src="@/assets/images/slidersHome/granada.jpg"
            data-text="Tecnología de punta en todos nuestros procesos."
            alt="Granada">
          <img src="@/assets/images/slidersHome/mango.jpg" data-text="Color y sabor." alt="Mango">
          <img src="@/assets/images/slidersHome/pera.jpg" data-text="Saludable y nutritiva." alt="Pera">
        </banner-slider>
      </div>
      <div class="grid">
        <router-link to="/empresa" class="experiencia flex">
          <div class=" flex">
            <div class="frase">
              <h3 class="titulo">Más de 45 años</h3>
              <p>La experiencia seleccionando las mejores frutas</p>
            </div>
          </div>
        </router-link>

         <router-link to="/empresa" class="alm flex">
          <div class=" flex">
            <div class="frase">
              <h3 class="titulo">Capacidad para almacenar</h3>
              <p>grandes cantidades de fruta en optimas condiciones</p>
            </div>
          </div>
        </router-link>

        <router-link to="/contacto" class="atencion flex">
          <div class="flex">
            <div class="frase">
              <h3 class="titulo">Atencion al cliente</h3>
              <p>Una atención de primera a nuestros clientes</p>
            </div>
          </div>
        </router-link>
      </div>
      <div class="proveedores">
        <h2 class="titulo">Proveedores</h2>
        <div class="slide">
          <swiper :options="swiperOption" :loop="true">
            <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner1.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner2.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner3.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner4.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner5.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner6.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner7.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner8.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner9.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner10.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner11.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner12.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner13.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner14.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner15.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner16.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner17.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner18.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner19.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner20.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner21.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner22.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner23.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner24.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner25.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner26.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner27.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner28.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner29.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner30.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner31.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner32.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner33.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner34.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner35.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner36.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner37.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner38.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner39.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner40.png" alt="RIOblanco">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner41.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner42.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner43.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner44.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner45.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner46.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner47.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner48.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner49.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner50.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner51.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner52.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner53.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner54.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner55.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner56.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner57.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner58.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner59.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner60.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner61.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner62.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner63.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner64.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner65.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner66.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner67.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner68.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner69.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner70.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner71.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner72.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner73.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner74.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner75.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner76.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner77.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner78.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner79.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner80.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner81.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner82.png" alt="RIOblanco">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner83.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner84.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner85.png" alt="RIOblanco">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner86.png" alt="RIOblanco">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner87.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner88.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner89.png" alt="RIOblanco">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner90.png" alt="RIOblanco">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner91.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner92.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner93.png" alt="RIOblanco">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner94.png" alt="RIOblanco">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner95.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner96.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner97.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner98.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner99.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner100.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner101.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner102.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner103.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner104.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner105.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import BannerSlider from '@/components/BannerSlider.vue';

export default {
  name: 'home',
  components: {
    BannerSlider,
  },
  data() {
    return {
      show: false,
      swiperOption: {
        breakpoints: {
          1024: {
            slidesPerView: 3,
          },
          600: {
            slidesPerView: 1,
          },
        },
        slidesPerView: 5,
        loop: true,
        spaceBetween: 30,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    };
  },
  computed: {

    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background-color: #00000085;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  .modal {
    width: 80vw;
    height: 40vw;
    position: relative;
    b {
      font-family: 'Avenir', sans-serif;
      cursor: pointer;
      font-size: 2em;
      top: -1em;
      right: 0px;
      color: #fff;
      position: absolute;
    }
    iframe {
      width: 100%;
      height: 100%;
    }
  }
}
.home {
  .container-home {
    background: #ffffff;

    .swiper-container {
    width: 100%;
    height: 20vh;
    }

    .slide {
      width: 100%;
    }
    .grid {
      color: #fff;
      width: 80vw;
      margin: 0px auto;
      display: grid;
      // display: -ms-grid;
      grid-gap: 15px;
      grid-template-areas:
        "exp alm"
        "exp ate";
      // grid-template-columns: repeat(2, 1fr);
      // grid-template-rows: 50% 50%;
      height: 100vh;
      transition: all ease 1s;
      position: relative;
      top: -2vh;


      .video {
        grid-area: vid;

        iframe {
          width: 100%;
          height: 100%;
        }
      }

      .experiencia {
        text-decoration: none;
        color: #fff;
        // background: #00000090;
        background-image: url('../assets/images/home1.png');
        background-position: center;
        background-size: cover;
        grid-area: exp;
        transition: all ease 1s;

          & :hover {
           transform: scale(1.05);
        }

      }
      .alm {
        text-decoration: none;
        color: #fff;
        // background: #b9b9b990;
        background-image: url('../assets/images/home2.png');
        background-position: center;
        background-size: cover;
        grid-area: alm;
        transition: all ease 1s;

          & :hover {
           transform: scale(1.05);
        }

      }
      .atencion {
        text-decoration: none;
        color: #fff;
        // background: #000fff90;
        background-image: url('../assets/images/home3.png');
        background-position: center;
        background-size: cover;
        grid-area: ate;
        transition: all ease 1s;

          & :hover {
           transform: scale(1.05);
        }

      }

    }


      .flex {
        display: flex;
        justify-content: flex-end;
        flex-direction: column;
        transition: inherit;

        .frase {
          display: flex;
          justify-content: flex-end;
          align-items: flex-start;
          flex-direction: column;
          margin-left: 7%;
          margin-bottom: 7%;
          transition: inherit;

          :hover {
            transform: none;
          }

          .titulo {
          font-weight: bold;
          font-size: 2.2em;
          margin-bottom: 0px;
          text-align: start;
          transition: inherit;

          :hover {
            transform: none;
          }
          }

          p {
            font-weight: 400;
            font-size: 1.2rem;
            transition: none;
            margin: 0;

            :hover {
              transform: none;
            }
          }
        }
      }

      .proveedores {
        margin-top: 5vh;
          .titulo {
          font-weight: bold;
          font-size: 2.2em;
          color: #000;
          }
          .slide {
            .prov {

              img {
                   width: 58%;
                   height: 100%;
                   max-height: 100%;
                   max-width: 100%;
              }
            }
          }
      }
    }
  }
@media screen and (max-width: 900px){
  .grid {
  grid-template-areas:
    "exp"
    "alm"
    "ate" !important;
  height: 150vh !important;
  width: 100% !important;
}
 .proveedores {
          .titulo {
          font-size: 2.2em;
          }
 }
 .home .container-home .proveedores div.slide .prov img {
   width: 40%;
 }
}
</style>
